module.exports = __webpack_public_path__ + "resource/img/news_more.png?a33d647f62a56b408cff907f75e79602";


//////////////////
// WEBPACK FOOTER
// ./src/images/news_more.png
// module id = 186
// module chunks = 36